import {
    UPDATE_DISCOUNT,
    UPDATE_DISCOUNT_FAILURE,
    UPDATE_DISCOUNT_SUCCESS,
} from 'store/actions/types';

export const updateDiscount = (payload) => {
    return {
        type: UPDATE_DISCOUNT,
        payload: payload,
    };
};

export const updateDiscountFailure = (error) => {
    return {
        type: UPDATE_DISCOUNT_FAILURE,
        error: error,
    };
};

export const updateDiscountSuccess = (payload, response) => {
    return {
        type: UPDATE_DISCOUNT_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/discounts/updateDiscounts.js